import React,{useState,useContext,useEffect} from 'react'
// import { Link,useNavigate } from 'react-router-dom';
import { ProductContext } from './Productcontext';

import alice_small from '../images/alicepage/alice_small.png';
import alice_small2x from '../images/alicepage/alice_small@2x.png';

import eart_test_link_small from '../images/earthingtestlink/earthing_testlink_small.png';
import eart_test_link_small2x from '../images/earthingtestlink/earthing_testlink_small@2x.png';

import equibusbar from '../images/equipotential/equipotential_busbar_small.png';
import equibusbar2x from '../images/equipotential/equipotential_busbar_small@2x.png';

import slprmast from '../images/slprmast/mast_small.png';
import slprmast2x from '../images/slprmast/mast_small@2x.png';
    
import slpracc from '../images/earthingtestlink/slpr_accessories_kit.png';
import slpracc2x from '../images/earthingtestlink/slpr_accessories_kit2x.png';
import Image from 'next/image';

import { useRouter,usePathname } from 'next/navigation';
import styles from './LightningAccessoriesSubMenu.module.css'



    const LightningAccessoriesSubMenu = () => {
       // let navigate = useNavigate();
       const router = useRouter();
       const pathname = usePathname()
        //const [selectedItem, setSelectedItem] = useState(null);
        const { selectedLightacc, setLightacc,setCategory, selectedProduct  } = useContext(ProductContext);

           // this for menu or fotter active item manage
           const [activeItem, setActiveItem] = useState(() => {
            if (typeof window !== 'undefined') {
              return localStorage.getItem('activeItem') || null;
            }
            return null;
          });
        
          // Update activeItem in localStorage whenever it changes
          useEffect(() => {
            if (activeItem) {
              localStorage.setItem('activeItem', activeItem);
            }
            console.log("use effect active item="+activeItem);
          }, [activeItem]);

        const handleItemClick = (item) => {
          //  setSelectedItem(item);
            setCategory('slpr');
            localStorage.setItem('activeItem', 'slpr');
            setLightacc(item);
            localStorage.setItem('selectedItem', 'item');
            if(item =='access')
                router.push('/ashlok-alice-digital');
            else if(item =='earth_test_link')
                router.push('/ashlok-earthing-test-link');
            else if(item =='equi_busbar')
                router.push('/ashlok-equipotential-busbar');
            else if(item =='slpr_mast')
                router.push('/ashlok-slpr-mast');
            else if(item =='slpr_acc')
                router.push('/ashlok-slpr-accessories-kit');
            else
                router.push('/ashlok-alice-digital');

            
          };

          useEffect(() => {
           // console.log("asp tah="+pathname );
            const handlePath = () => {
                if (pathname) {
                    const path = pathname.split('/').pop();
                   // console.log("path="+path );
                    // Match path to selected product
                    switch (path) {
                        case 'ashlok-thor-safe-protection-lightning-rod':
                           // setSelectedItem('thor');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'thor');
                            break;
                        case 'ashlok-zeus-slpr':
                            // setSelectedItem('zeus');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'zeus');
                            break;
                        case 'ashlok-air-terminal':
                            // setSelectedItem('air');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'air');
                            break;
                        case 'ashlok-franklyn-penta':
                            // setSelectedItem('frank');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'frank');
                            break;
                        case 'ashlok-surge-protection-device':
                            // setSelectedItem('spd');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'spd');
                            break;
                        case 'ashlok-exothermic-welding-kit':
                            // setSelectedItem('exo_kit');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'exo_kit');
                            break;
                        case 'ashlok-lightning-accessories':
                            setLightacc('access');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'access');
                            break;
                        case 'ashlok-alice-digital':
                            setLightacc('alice_digital');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'alice_digital');
                            break;
                       case 'ashlok-earthing-test-link':
                            setLightacc('earth_test_link');
                             setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'earth_test_link');
                            break;
                        case 'ashlok-equipotential-busbar':
                            setLightacc('equi_busbar');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'equi_busbar');
                            break;
                        case 'ashlok-slpr-mast':
                            setLightacc('slpr_mast');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'slpr_mast');
                            break;
                        case 'ashlok-slpr-accessories-kit':
                            setLightacc('slpr_acc');
                            setCategory('slpr');
                            localStorage.setItem('selectedCategory', 'slpr');
                            localStorage.setItem('selectedItem', 'slpr_acc');
                            break;
                        default:
                            break;
                    }
                }
            };
    
            // Defer execution to allow for router initialization
            const timer = setTimeout(handlePath, 100);
    
            return () => clearTimeout(timer); // Cleanup timeout
        }, [pathname,setCategory,setLightacc]);
      return (
       <div className=' w-full flex  '>
            <div className=' container mx-auto flex flex-col lg:flex-row justify-center items-center my-2'>
            
                <div className={`w-full lg:w-1/5 h-10 lg:h-32  my-2 flex  lg:flex-col justify-center lg:justify-end  items-center   ml-6 lg:ml-1 mr-1 cursor-pointer hover:cursor-pointer `} onClick={() => handleItemClick('alice_digital')}>
                    <div  className={`m-2 flex items-center ${styles.noMaxWidth} hidden lg:block`}><Image src={alice_small} alt="alice_small"/></div>
                    <div  className='relative bg-gray-500 text-white rounded-sm text-center lg:bg-white lg:text-black p-2 py-2 w-[100%] sm:w-[42%] md-small:w-[42%] md:w-[42%] lg:w-[100%]'><div className={` text-base  font-semibold ${selectedLightacc === 'alice_digital' ?  ' text-ashblack lg:text-ashred' : ''}`} style={{ fontFamily: 'Rajdhani, sans-serif' }}><div className=' text-xs md:text-base lg:text-base flex flex-row lg:flex-col space-x-2 sm:space-x-1 lg:space-x-0 px-[0.5rem] lg:px-0 '><div className="absolute top-0 left-0 h-full w-1/6 bg-gray-700 rounded-l-sm block lg:hidden px-[5%] pt-[4%]"><Image src={alice_small} alt="alice_small" className='w-full'/></div><div className='flex pl-[14%] lg:pl-0  lg:pr-0 justify-center items-center'><span className='vollkorn-sc-semibold   lg:pl-6 '>A.L.I.C.E Digital</span></div></div></div></div>
                </div>
                <div className={`w-full lg:w-1/5 h-10 lg:h-32  my-2 flex lg:flex-col justify-center lg:justify-end items-center  ml-6 lg:ml-1 mr-1 cursor-pointer hover:cursor-pointer`} onClick={() => handleItemClick('earth_test_link')}>
                    <div  className={`m-1 flex items-center ${styles.noMaxWidth} hidden lg:block`}><Image src={eart_test_link_small} alt="zeud ico"/></div>
                    <div  className=' relative bg-gray-500 text-white  rounded-sm text-center lg:bg-white lg:text-black p-2 w-[100%] sm:w-[42%] md-small:w-[42%] md:w-[42%] lg:w-[100%]'><div className={` text-base  font-semibold ${selectedLightacc === 'earth_test_link' ? 'text-ashblack lg:text-ashred' : ''}`} style={{ fontFamily: 'Rajdhani, sans-serif' }}> <div className=' text-xs md:text-base lg:text-base flex flex-row lg:flex-col space-x-2 sm:space-x-1 lg:space-x-0 px-[0.5rem] lg:px-0 '> <div className="absolute top-0 left-0 h-full w-1/6 bg-gray-700 rounded-l-sm block lg:hidden px-[5%]"><Image className='h-full flex' src={eart_test_link_small} alt="zeud ico"/></div> <div className='flex pl-[14%] lg:pl-0  lg:pr-0 justify-center items-center'><span className='vollkorn-sc-semibold  lg:pl-0 '>Earthing Test Link</span></div></div></div></div>
                </div>
                <div className={`w-full lg:w-1/5 h-10 lg:h-32 my-2 flex lg:flex-col justify-center lg:justify-end  items-center  ml-6 lg:ml-1 mr-1 cursor-pointer hover:cursor-pointer`}  onClick={() => handleItemClick('equi_busbar')}>
                    <div  className={`m-2 flex items-center ${styles.noMaxWidth} hidden lg:block`}><Image src={equibusbar} alt="ele ico"/></div>
                    <div  className='relative bg-gray-500 text-white  rounded-sm text-center lg:bg-white lg:text-black p-2 py-2 w-[100%] sm:w-[42%] md-small:w-[42%] md:w-[42%] lg:w-[100%]'><div className={` text-base  font-semibold ${selectedLightacc === 'equi_busbar' ? 'text-ashblack lg:text-ashred' : ''}`} style={{ fontFamily: 'Rajdhani, sans-serif' }}><div className=' text-xs md:text-base lg:text-base flex flex-row lg:flex-col space-x-2 sm:space-x-1 lg:space-x-0 px-[0.5rem] lg:px-0 '><div className="absolute top-0 left-0 h-full w-1/6 bg-gray-700 rounded-l-sm block lg:hidden px-[5%]"><Image className='h-full flex' src={equibusbar} alt="ele ico"/></div><div className='flex pl-[14%] lg:pl-0  lg:pr-0 justify-center items-center'><span className='vollkorn-sc-semibold  lg:pl-0 '>Equipotential Busbar</span></div></div></div></div>
                </div>
                <div className={`w-full lg:w-1/5 h-10 lg:h-32 my-2 flex lg:flex-col justify-center lg:justify-end items-center  ml-6 lg:ml-1 mr-1 cursor-pointer hover:cursor-pointer`}  onClick={() => handleItemClick('slpr_mast')}>
                    <div  className={`flex items-center ${styles.noMaxWidth} hidden lg:block`}><Image src={slprmast} alt="bfc ico"/></div>
                    <div  className=' relative bg-gray-500 text-white  rounded-sm text-center lg:bg-white lg:text-black p-2 py-2 w-[100%] sm:w-[42%] md-small:w-[42%] md:w-[42%] lg:w-[100%]'><div className={` text-base  font-semibold ${selectedLightacc === 'slpr_mast' ? 'text-ashblack lg:text-ashred' : ''}`} style={{ fontFamily: 'Rajdhani, sans-serif' }}><div className=' text-xs md:text-base lg:text-base flex flex-row lg:flex-col space-x-2 sm:space-x-1 lg:space-x-0 px-[0.5rem] lg:px-0 '><div className="absolute top-0 left-0 h-full w-1/6 bg-gray-700 rounded-l-sm block lg:hidden px-[5%]"><Image className=' flex h-[80%] pt-[40%]' src={slprmast} alt="bfc ico"/></div><div className='flex pl-[14%] lg:pl-0  lg:pr-0 justify-center items-center'><span className='vollkorn-sc-semibold  lg:pl-0'>Ashlok’s SLPR Mast</span></div></div></div></div>
                    
                </div>
                <div className={`w-full lg:w-1/5 h-10 lg:h-32 my-2 flex lg:flex-col justify-center lg:justify-end  items-center  ml-6 lg:ml-1 mr-1 cursor-pointer hover:cursor-pointer`} onClick={() => handleItemClick('slpr_acc')}>
                    <div  className={`m-5 flex items-center ${styles.noMaxWidth} hidden lg:block`}><Image src={slpracc} alt="epcc ico"/></div>
                    <div  className='relative bg-gray-500 text-white  rounded-sm text-center lg:bg-white lg:text-black p-2 py-2 w-[100%] sm:w-[42%] md-small:w-[42%] md:w-[42%] lg:w-[100%]' ><div className={` text-base  font-semibold ${selectedLightacc === 'slpr_acc' ? 'text-ashblack lg:text-ashred' : ''}`} style={{ fontFamily: 'Rajdhani, sans-serif' }}><div className=' text-xs md:text-base lg:text-base flex flex-row lg:flex-col space-x-2 sm:space-x-1 lg:space-x-0 px-[0.5rem] lg:px-0 '><div className="absolute top-0 left-0 h-full w-1/6 bg-gray-700 rounded-l-sm block lg:hidden px-[5%]"><Image className='h-[80%] flex  pt-[40%]' src={slpracc} alt="epcc ico"/></div><div className='flex pl-[14%] lg:pl-0  lg:pr-0 justify-center items-center'><span className='vollkorn-sc-semibold  lg:pl-0 '>SLPR Accessories Kit</span></div></div></div></div>
                </div>
                

            </div>
          
        </div>
      )
    }
    
    export default LightningAccessoriesSubMenu
    

  